/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type QuickViewCreators_item = {
    readonly quickViewDisplay: {
        readonly creators: ReadonlyArray<{
            readonly displayName: string;
            readonly linkData: {
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null> | null;
    } | null;
    readonly " $refType": "QuickViewCreators_item";
};
export type QuickViewCreators_item$data = QuickViewCreators_item;
export type QuickViewCreators_item$key = {
    readonly " $data"?: QuickViewCreators_item$data;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewCreators_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "QuickViewCreators_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "quickViewDisplay",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewDisplayType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "creators",
          "storageKey": null,
          "args": null,
          "concreteType": "QuickViewCreator",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "linkData",
              "storageKey": null,
              "args": null,
              "concreteType": "LinkData",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "SeoLink_linkData",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '4d8c6e9dbb4cc7e0cefdc11a6e54298b';
export default node;
